import * as XLSX from 'xlsx';

export const generarExcel = (nombreArchivo, datos) => {
  try {
    // Verificar si hay datos
    if (!datos || datos.length === 0) {
      alert('No hay datos para exportar');
      return;
    }

    // Crear hoja de cálculo
    const worksheet = XLSX.utils.json_to_sheet(datos);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

    // Generar archivo
    XLSX.writeFile(workbook, nombreArchivo);
    alert(`Archivo ${nombreArchivo} generado correctamente`);
  } catch (error) {
    console.error('Error al generar Excel:', error);
    alert('Error al generar el archivo Excel');
  }
};

// Función para obtener datos 
export const obtenerDatos = (key) => {
  return JSON.parse(localStorage.getItem(key)) || [];
};

// Función para actualizar datos
export const actualizarDatos = (key, nombreArchivo, nuevosDatos) => {
  localStorage.setItem(key, JSON.stringify(nuevosDatos));
  generarExcel(nombreArchivo, nuevosDatos);
};